import {gql} from "apollo-boost";

export const LatestInscriptionQuery = gql`
    query GetLatestInscription($beneficiaryDocType: Int!,$beneficiaryDocument: String!,$institutionId: Int!,$scheduleId: Int!) {
        getLatestInscription(beneficiaryDocType:$beneficiaryDocType, beneficiaryDocument:$beneficiaryDocument, institutionId:$institutionId, scheduleId:$scheduleId) {
            affiliateDocType
            affiliateDocument
            beneficiaryDocType
            beneficiaryDocument
            institutionId
            scheduleId
            levelId
            programId
            degreeId
            birthDate
            beneficiaryName
            beneficiaryLastName
            affiliateName
            affiliateLastName
            processId
            processComplete
            contact
            phoneContact
            email
            emailCode
	        emailConfirmed
        }
    }
`;